import { render, staticRenderFns } from "./blogs_archive.vue?vue&type=template&id=f4be56a6"
import script from "./blogs_archive.vue?vue&type=script&lang=js"
export * from "./blogs_archive.vue?vue&type=script&lang=js"
import style0 from "./blogs_archive.vue?vue&type=style&index=0&id=f4be56a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports